export const environment = {
  production: false,
  apiDomain: 'argo.ml3ds-rt-stage.com',
  panoResourcesBaseUrl: 'https://argo.ml3ds-rt-stage.com/panoresources',
  buildNumber: '242',
  isOffline: false
};
